export default __webpack_public_path__ + "static/media/480_dummy2016-moebelbauer01-mobile-de.095eb55d.png";